﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrganizationActionTypes;
(function (OrganizationActionTypes) {
    OrganizationActionTypes["UpdateOrganizations"] = "UPDATE_ORGANIZATIONS";
})(OrganizationActionTypes = exports.OrganizationActionTypes || (exports.OrganizationActionTypes = {}));
exports.actionCreators = {
    updateOrganizations: (organizations) => ({
        type: OrganizationActionTypes.UpdateOrganizations,
        payload: organizations
    }),
};
//# sourceMappingURL=actions.js.map